import { buildPanelItem } from "../helpers/buildPanelItem";
import { captureInformationGeoPanel } from "./captureInformationGeo";
import { Collapse } from "antd";
import { Label } from "../components/Label";

export const captureInformationPanel = [
  buildPanelItem(
    "1",
    Label({ label: "os", type: "string" }),
    "The operational system of the device where the authentication data was captured.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "device", type: "string" }),
    "The device name where the authentication data was captured.",
  ),
  buildPanelItem(
    "3",
    Label({ label: "browser", type: "string" }),
    "The name of the browser used to capture the authentication.",
  ),
  buildPanelItem(
    "4",
    Label({ label: "geolocation", type: "object" }),
    null,
    <Collapse items={captureInformationGeoPanel} />,
  ),
];
